const Vue = require('vue');
const Vuex = require('vuex');
import _ from 'lodash';
import { get } from '@/api/index';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    merchantInfo: {},
    anchorInfo: {},
    activityConfig: {},
    anchorConfig: {},
    videoConfig: {
      types: [
        {
          name: '全部风格',
          value: 0,
        },
        {
          name: '口播种草',
          value: 1,
        },
        {
          name: '情景在线',
          value: 2,
        },
        {
          name: '线下探店',
          value: 4,
        },
        {
          name: '开箱测评',
          value: 5,
        },
        {
          name: '深度评测',
          value: 6,
        },
        {
          name: '品牌类视频',
          value: 7,
        },
        {
          name: '风格化视频',
          value: 8,
        },
        {
          name: '潮流变装',
          value: 9,
        },
      ],
      category: [
        {
          name: '全部品类',
          value: 0,
        },
        {
          name: '食品',
          value: 1,
        },
        {
          name: '美妆',
          value: 9,
        },
        {
          name: '服饰鞋包',
          value: 2,
        },
        {
          name: '母婴亲子',
          value: 3,
        },
        {
          name: '个护家清',
          value: 4,
        },
        {
          name: '生活电器',
          value: 5,
        },
        {
          name: '珠宝配饰',
          value: 6,
        },
        {
          name: '运动户外',
          value: 7,
        },
        {
          name: '宠物用品',
          value: 8,
        },
      ],
    },
    // 活动服务类型列表
    actServiceTypeValueList: [1, 2],
    actServiceTypeList: [
      {
        name: '混播',
        value: 1,
        category: [],
      },
      {
        name: '专场',
        value: 2,
        category: [],
      },
    ],
    // 达人渠道
    anchorChannel: [
      {
        label: '抖音',
        value: 1,
      },
      {
        label: '小红书',
        value: 2,
      },
      {
        label: '淘宝',
        value: 3,
      },
      {
        label: '微博',
        value: 4,
      },
      {
        label: '快手',
        value: 5,
      },
    ],
    // 接单账号渠道
    accountPlatforms: [
      {
        name: '抖音',
        prop: 'douyin',
        value: 1,
      },
      {
        name: '淘宝',
        prop: 'taobao',
        value: 3,
      },
      {
        name: '快手',
        prop: 'kuaishou',
        value: 5,
      },
    ],
    // 投诉类型下拉列表
    complainTypes: [],
    // 广告位
    merchantAds: [],
    // 短视频类目
    videoCategory: [],
    // 短视频类型
    videoType: [],
    // 优质达人擅长类目
    anchorCategoryInfo: [],
    // 购物车数量
    selectShoppingCartAnchor: 0,
  },
  getters: {
    isLogin: state => {
      const userInfo = state.userInfo;
      return Boolean(userInfo.id);
    },
    userType: state => {
      const userInfo = state.userInfo;
      return userInfo.type;
    },
    isUser: state => {
      const userInfo = state.userInfo;
      return userInfo.type === 'user';
    },
    isDaRen: state => {
      const userInfo = state.userInfo;
      return userInfo.type === 'daren';
    },
    platformByValue: state => {
      const platform = _.get(state, 'anchorConfig.platform', []);
      return _.keyBy(platform, 'value');
    },
  },
  mutations: {
    SET_CONFIG(state, config) {
      const { activity_list, anchor_list, activity_registration_platform } = config;
      state.activityConfig = activity_list;
      state.anchorConfig = anchor_list;
      state.activity_registration_platform = activity_registration_platform;
    },
    SET_USERINFO(state, data) {
      state.userInfo = data;
    },
    SET_COMPLAINTYPES(state, data) {
      state.complainTypes = data;
    },
    SET_MERCHANTINFO(state, data) {
      state.merchantInfo = data;
    },
    SET_ANCHORINFO(state, data) {
      state.anchorInfo = data;
    },
    SET_MERCHANTADS(state, data) {
      state.merchantAds = data;
    },
    SET_VIDEOCATEGORY(state, data) {
      state.videoCategory = data;
    },
    SET_VIDEOTYPE(state, data) {
      state.videoType = data;
    },
    SET_ANCHORCATEGORY(state, data) {
      state.anchorCategoryInfo = data;
    },
    SET_SELECTSHOPPINGCARTANCHOR(state, data) {
      state.selectShoppingCartAnchor = data;
    },
  },
  actions: {
    // 获取全局配置信息
    getConfigMenu({ commit }) {
      get({
        road: 'configMenu',
      }).then(res => {
        if (res.code === 0) {
          console.log('setConfig1111111111111111111', res.data);
          commit('SET_CONFIG', res.data);
        }
      });
    },
    // 退出登录
    logout({ commit }, callback) {
      get({
        road: 'logout',
      })
        .then(res => {
          if (res.code === 0) {
            commit('SET_USERINFO', {});
            localStorage.removeItem('company_mobile');
            localStorage.removeItem('company_list');
            localStorage.removeItem('token');
          }
        })
        .finally(() => {
          callback && callback();
        });
    },
    // 获取用户信息
    getUserInfo({ commit }) {
      get({
        road: 'userInfo',
        extra: { notVerifyToken: true, showMessage: false },
      }).then(res => {
        if (res.code === 0) {
          commit('SET_USERINFO', res.data);
        }
      });
    },
    // 获取投诉类型下拉列表
    getComplainTypes({ commit }) {
      get({
        road: 'complainTypes',
      }).then(res => {
        if (res.code === 0) {
          commit('SET_COMPLAINTYPES', res.data);
        }
      });
    },
    // 获取商家个人中心信息
    getMerchantInfo({ commit }) {
      get({
        road: 'businessInfo',
      }).then(res => {
        if (res.code === 0) {
          commit('SET_MERCHANTINFO', res.data);
        }
      });
    },
    // 获取个人中心广告位
    getMerchantAds({ commit }) {
      get({
        road: 'merchantAds',
      }).then(res => {
        if (res.code === 0) {
          commit('SET_MERCHANTADS', res.data);
        }
      });
    },
    // 获取主播个人中心信息
    getDaRenInfo({ commit }) {
      get({
        road: 'personalCenterInfo',
      }).then(res => {
        if (res.code === 0) {
          commit('SET_ANCHORINFO', res.data);
        }
      });
    },
    // 获取短视频配置
    getVideoConfig({ commit }) {
      get({
        road: 'videoCategory',
      }).then(res => {
        if (res.code === 0) {
          commit(
            'SET_VIDEOCATEGORY',
            [
              {
                name: '全部类目',
                value: '',
                enable: 1,
              },
            ].concat(res.data)
          );
        }
      });
      get({
        road: 'videoType',
      }).then(res => {
        if (res.code === 0) {
          if (res.code === 0) {
            commit(
              'SET_VIDEOTYPE',
              [
                {
                  name: '全部风格',
                  value: '',
                  enable: 1,
                },
              ].concat(res.data)
            );
          }
        }
      });
    },
    // 获取优质达人擅长类目
    getCategory({ commit }) {
      get({
        road: 'getCategory',
        query: {
          paginate: 10000,
          page: 1,
        },
      }).then(res => {
        if (res.code === 0) {
          commit('SET_ANCHORCATEGORY', res.data);
        }
      });
    },
    // 获取已选达人数量
    getShoppingCartAmount({ commit }) {
      get({ road: 'shoppingCartAmount', extra: { notVerifyToken: true, showMessage: false } }).then(
        res => {
          if (res.code === 0) {
            commit('SET_SELECTSHOPPINGCARTANCHOR', res.data.count);
          }
        }
      );
    },
  },
  modules: {},
});
